// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .button-panel {
  position: absolute;
  left: 4px;
  top: 20%;
  margin-top: -32px;
  padding-left: 0;
  touch-action: none;
}

.escher-container .button-panel>li {
  margin-top: 5px;
  display: block;

  /* these sometimes get overridden */
  margin-left: 0 !important;
}

.escher-container .grouping {
  display: block;
}

.escher-container .buttonGroup {
  display: block;
  margin-bottom: -1px;
  padding: 5px 0px;
  border-radius: 0;
}

.escher-container .grouping>.buttonGroup:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.escher-container .grouping>.buttonGroup:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.escher-container .button-panel>.grouping:last-child {
  margin-top: 4px;
}

.escher-container #currentMode,
.escher-container .active-button {
  background-image: linear-gradient(#8F4F3F,#834c3c 6%,#8d3a2d) !important;
}

.escher-container .buttonGroup.btn {
  margin-top: -1px;
}

.escher-container .button {
  border-radius: 4px;
}

.escher-container .button.btn, .escher-container .buttonGroup.btn {
  padding: unset;
  color: white!important;
  border: 1px solid #474949;
  background-image: linear-gradient(#4F5151, #474949 6%, #3F4141);
  background-color: white;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px!important;
  font-weight: 400;
  width: 40px;
  height: 40px;
}

.escher-container .button-panel .button:active, .escher-container .buttonGroup label:active, .escher-container .button-panel .buttonGroup:active {
  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);
}

.escher-container .button-panel .fa {
  font-size: 24px;
}

/* Icons */
.escher-container .button-panel [class^='icon-'] {
  font-size: 23px;
}
`, "",{"version":3,"sources":["webpack://./src/ButtonPanel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;;EAEd,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,+DAA+D;EAC/D,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB","sourcesContent":[".escher-container .button-panel {\n  position: absolute;\n  left: 4px;\n  top: 20%;\n  margin-top: -32px;\n  padding-left: 0;\n  touch-action: none;\n}\n\n.escher-container .button-panel>li {\n  margin-top: 5px;\n  display: block;\n\n  /* these sometimes get overridden */\n  margin-left: 0 !important;\n}\n\n.escher-container .grouping {\n  display: block;\n}\n\n.escher-container .buttonGroup {\n  display: block;\n  margin-bottom: -1px;\n  padding: 5px 0px;\n  border-radius: 0;\n}\n\n.escher-container .grouping>.buttonGroup:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.escher-container .grouping>.buttonGroup:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.escher-container .button-panel>.grouping:last-child {\n  margin-top: 4px;\n}\n\n.escher-container #currentMode,\n.escher-container .active-button {\n  background-image: linear-gradient(#8F4F3F,#834c3c 6%,#8d3a2d) !important;\n}\n\n.escher-container .buttonGroup.btn {\n  margin-top: -1px;\n}\n\n.escher-container .button {\n  border-radius: 4px;\n}\n\n.escher-container .button.btn, .escher-container .buttonGroup.btn {\n  padding: unset;\n  color: white!important;\n  border: 1px solid #474949;\n  background-image: linear-gradient(#4F5151, #474949 6%, #3F4141);\n  background-color: white;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  font-size: 14px!important;\n  font-weight: 400;\n  width: 40px;\n  height: 40px;\n}\n\n.escher-container .button-panel .button:active, .escher-container .buttonGroup label:active, .escher-container .button-panel .buttonGroup:active {\n  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);\n}\n\n.escher-container .button-panel .fa {\n  font-size: 24px;\n}\n\n/* Icons */\n.escher-container .button-panel [class^='icon-'] {\n  font-size: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
